// Use the query string values to populate the form. Expects an object, where
// the key is the name of the search param, and the value the ID of the input
const fillFormUsingQueryString = (paramsAndInputs = {}) => {
  const searchParams = new URLSearchParams(window.location.href.split('?')[1]);

  Object.entries(paramsAndInputs).forEach(([paramName, inputId]) => {
    const input = document.getElementById(inputId);

    if (input) {
      input.value = searchParams.get(paramName);
    }
  });
};

export { fillFormUsingQueryString };
